import { combineReducers } from 'redux';
import ongoing from './ongoing/reducer';
import request from './request/reducer';

export default combineReducers({
    ongoing,
    request
});



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/reducer.js